import React from 'react'
import { Chip, SxProps, type ChipProps } from '@mui/material'
import { merge } from 'es-toolkit/compat'

import { TagColor } from '@core/styles/colors'

export type CustomTagProps = ChipProps & {
  tagColor: TagColor
  selected?: boolean
  sxOverride?: ChipProps['sx']
  rounded?: boolean
}

const roundedStyles: SxProps = {
  py: 1.5,
  px: 1,
  borderRadius: 12,
  fontSize: '0.735rem',
  fontWeight: 600,
  letterSpacing: '-0.15px',
}

// @TODO: move this component to out of /deliver folder (deprecated path)
export const CustomTag = React.forwardRef<HTMLDivElement, CustomTagProps>((props, ref) => {
  const { tagColor, selected, sxOverride, rounded, ...rest } = props

  const styles: ChipProps['sx'] = merge(
    {
      bgcolor: `tag.${tagColor}.main`,
      color: `tag.${tagColor}.contrastText`,
      borderRadius: 0.75,
      py: 0,
      px: 1,
      fontSize: '0.875rem',
      lineHeight: '1rem',
      height: 20,
      opacity: selected === undefined || selected ? '1' : '0.5',
      '&.MuiChip-clickable': {
        '&:hover, &:focus': {
          bgcolor: `tag.${tagColor}.dark`,
        },
      },
      '& .MuiChip-avatar': {
        bgcolor: `tag.${tagColor}.avatarBg`,
      },
      ...(rounded ? roundedStyles : {}),
    },
    sxOverride,
  )

  return <Chip {...rest} ref={ref} sx={styles} />
})

CustomTag.displayName = 'CustomTag'

export default CustomTag
